import React, { Component } from "react";
import { Link } from "react-router-dom";

import "./styles/Header.scss";

import { ReactComponent as SiemensLogo } from "../static/logos/sie-logo-white-rgb.svg";
import { clearAuthentication } from "../utils/auth-utils";

export default class Header  extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isActive: false
    }
  }

  toggleBurgerMenu = () => {
    this.setState({isActive: !this.state.isActive})
  }

  render() {
    const showNavigation = this.props.showNavigation

    return (
      <nav
        className="navbar is-fixed-top"
        role="navigation"
        aria-label="main navigation"
      >
        <div className="navbar-brand">
          <a className="navbar-item" href="/">
            <SiemensLogo className="navbar-logo" />
          </a>
  
          {showNavigation && (
            <div
              className={`navbar-burger burger ${this.state.isActive ? "is-active" : ""}`}
              data-target="navbar"
              aria-label="menu"
              aria-expanded="false"
              onClick={this.toggleBurgerMenu}
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}
        </div>
  
        {showNavigation && (
          <div
            id="navbar"
            className={`navbar-menu ${this.state.isActive ? "is-active" : ""}`}
          >
            <div className="navbar-start">
              <Link
                to="/"
                className="navbar-item is-tab"
                onClick={this.toggleBurgerMenu}
              >
                New Notification
              </Link>
              <Link
                to="/notifications"
                className="navbar-item is-tab"
                onClick={this.toggleBurgerMenu}
              >
                Notifications
              </Link>
              <Link
                to="/recipients"
                className="navbar-item is-tab"
                onClick={this.toggleBurgerMenu}
              >
                Recipients
              </Link>
              <Link
                to="/statistics"
                className="navbar-item is-tab"
                onClick={this.toggleBurgerMenu}
              >
                Statistics
              </Link>
            </div>
  
            <div className="navbar-end">
              <div className="navbar-item">
                <a className="navbar-item" href="/" onClick={() => clearAuthentication()}>
                  Logout
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>
    );
  }
}
